export class GallerySelectToChat {
    constructor(optionalOptions = {}) {
        this.galleryAddButton = document.querySelector('.sheet-open-gallery--button .base-button');

        if (!this.galleryAddButton) {
            this.destructor();
            return true;
        }

        let selected;
        let imageArea;
        let imageAreaData;
        let imgDiv;
        let imgClose;

        this.galleryAddButton.addEventListener("click", (event) => {
            event.preventDefault();

            selected = document.querySelectorAll('.gallery-selectable .gallery-add--item.selected')
            if (selected) {
                imageArea = document.querySelector('.chat--chat-message--image-select')
                imageAreaData = imageArea.querySelector('.chat--chat-message-image-select--data')

                imageArea.classList.add('show')
                imageAreaData.innerHTML = "";

                selected.forEach((item) => {
                    if (item.dataset.src) {
                        imgDiv = document.createElement('div');
                        imgDiv.className = 'image';
                        imgDiv.style.backgroundImage="url('"+item.dataset.src+"')";

                        imgClose = document.createElement('div');
                        imgClose.className = 'delete';

                        imgClose.addEventListener('click', (event) => {
                            event.preventDefault();

                            if (imageAreaData.childNodes.length <= 1) {
                                imageArea.classList.remove('show')
                                imageAreaData.innerHTML = "";
                            } else {
                                event.target.parentNode.remove();
                            }
                        })

                        imgDiv.appendChild(imgClose);

                        imageAreaData.appendChild(imgDiv)
                    }
                })

                window.closeSheet();
            }
        });
    }

    destructor() {
        this.galleryAddButton = null;
    }
}

export default new GallerySelectToChat();